<template>
  <div v-if="this.isAdmin == false"> {{ this.$NOLIMITResource["VN"].PermissionPage }}</div>
  <!--begin::Content wrapper-->
  <div v-else class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div
      id="kt_app_toolbar"
      class="app-toolbar py-3 py-lg-6"
      style="padding-top: 0px !important; padding-bottom: 10px !important"
    >
      <!--begin::Toolbar container-->
      <div
        id="kt_app_toolbar_container"
        class="app-container d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <!--begin::Title-->
          <h1
            class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0"
          >
            Quản lý tất cả BillLog
          </h1>
          <!--end::Title-->
        </div>
        <!--end::Page title-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
          <div
            class="card-header border-0 pt-6"
            style="align-items: center; padding-top: 0px !important"
          >
            <!--begin::Card title-->
            <div class="card-title">
              <!--begin::Search-->
              <div class="d-flex align-items-center position-relative my-1">
                <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                  <span
                    @click="onEnterSearchFirst"
                    class="path1"
                    style="cursor: pointer; z-index: 2"
                  ></span>
                  <span class="path2"></span>
                </i>
                <input
                  v-on:keyup.enter="onEnterSearchFirst"
                  v-model="inputValue"
                  type="text"
                  class="form-control form-control-solid w-350px ps-12"
                  placeholder="Tìm kiếm theo mã gd, chủ tk, FBadsID, thẻ,..."
                />
              </div>
              <!--end::Search-->
            </div>

            <!--begin::Card toolbar-->
            <div class="card-toolbar" style="margin-left: auto">
              <!--begin::Toolbar-->
              <a id="selected__toolbar">Đã chọn <span>{{ countSelected }}</span></a>  
              <a @click="openModalAllCardInfo()" id="selectedall__toolbar">Thông tin thẻ</a>
              <a @click="confirmUpdateAllBillLogStatus()" id="selectedall__toolbar">Yêu cầu cập nhật tất cả</a>
              <div class="content__toolbar--table">
                <a @click="exportCSV()" id="selectedall__toolbar">Tải về CSV</a>
              </div>
              <div
                class="d-flex justify-content-end"
                data-kt-customer-table-toolbar="base"
              >
                <!--begin::Menu 1-->
                <div
                  class="menu menu-sub menu-sub-dropdown w-300px w-md-325px"
                  data-kt-menu="true"
                  id="kt-toolbar-filter"
                >
                  <!--begin::Header-->
                  <div class="px-7 py-5">
                    <div class="fs-4 text-gray-900 fw-bold">Filter Options</div>
                  </div>
                  <!--end::Header-->
                  <!--begin::Separator-->
                  <div class="separator border-gray-200"></div>
                  <!--end::Separator-->
                  <!--begin::Content-->
                  <div class="px-7 py-5">
                    <!--begin::Input group-->
                    <div class="mb-10">
                      <!--begin::Label-->
                      <label class="form-label fs-5 fw-semibold mb-3"
                        >Month:</label
                      >
                      <!--end::Label-->
                      <!--begin::Input-->
                      <select
                        class="form-select form-select-solid fw-bold"
                        data-kt-select2="true"
                        data-placeholder="Select option"
                        data-allow-clear="true"
                        data-kt-customer-table-filter="month"
                        data-dropdown-parent="#kt-toolbar-filter"
                      >
                        <option></option>
                        <option value="aug">August</option>
                        <option value="sep">September</option>
                        <option value="oct">October</option>
                        <option value="nov">November</option>
                        <option value="dec">December</option>
                      </select>
                      <!--end::Input-->
                    </div>
                    <!--end::Input group-->
                    <!--begin::Input group-->
                    <div class="mb-10">
                      <!--begin::Label-->
                      <label class="form-label fs-5 fw-semibold mb-3"
                        >Payment Type:</label
                      >
                      <!--end::Label-->
                      <!--begin::Options-->
                      <div
                        class="d-flex flex-column flex-wrap fw-semibold"
                        data-kt-customer-table-filter="payment_type"
                      >
                        <!--begin::Option-->
                        <label
                          class="form-check form-check-sm form-check-custom form-check-solid mb-3 me-5"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="payment_type"
                            value="all"
                            checked="checked"
                          />
                          <span class="form-check-label text-gray-600"
                            >All</span
                          >
                        </label>
                        <!--end::Option-->
                        <!--begin::Option-->
                        <label
                          class="form-check form-check-sm form-check-custom form-check-solid mb-3 me-5"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="payment_type"
                            value="visa"
                          />
                          <span class="form-check-label text-gray-600"
                            >Visa</span
                          >
                        </label>
                        <!--end::Option-->
                        <!--begin::Option-->
                        <label
                          class="form-check form-check-sm form-check-custom form-check-solid mb-3"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="payment_type"
                            value="mastercard"
                          />
                          <span class="form-check-label text-gray-600"
                            >Mastercard</span
                          >
                        </label>
                        <!--end::Option-->
                        <!--begin::Option-->
                        <label
                          class="form-check form-check-sm form-check-custom form-check-solid"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="payment_type"
                            value="american_express"
                          />
                          <span class="form-check-label text-gray-600"
                            >American Express</span
                          >
                        </label>
                        <!--end::Option-->
                      </div>
                      <!--end::Options-->
                    </div>
                    <!--end::Input group-->
                    <!--begin::Actions-->
                    <div class="d-flex justify-content-end">
                      <button
                        type="reset"
                        class="btn btn-light btn-active-light-primary me-2"
                        data-kt-menu-dismiss="true"
                        data-kt-customer-table-filter="reset"
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        data-kt-menu-dismiss="true"
                        data-kt-customer-table-filter="filter"
                      >
                        Apply
                      </button>
                    </div>
                    <!--end::Actions-->
                  </div>
                  <!--end::Content-->
                </div>
                <!--end::Menu 1-->
                <!--begin::Filter-->
                <button
                  @click="toggleMenuFilter"
                  type="button"
                  class="btn btn-light-primary me-3"
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end"
                >
                  <i class="ki-duotone ki-filter fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span> </i
                  >Lọc tìm kiếm
                </button>
                <!--begin::Menu 1-->
                <div
                  class="menu menu-sub menu-sub-dropdown w-300px w-md-325px show-dropfilter" 
                  :class="{ show: this.onShowMenuFilter == true }"
                  
                  data-kt-menu="true"
                  id="kt-toolbar-filter"
                  data-select2-id="select2-data-kt-toolbar-filter"
                  style="width: 450px !important;"
                >
                  <!--begin::Header-->
                  <div class="px-7 py-5">
                    <div class="fs-4 text-gray-900 fw-bold">
                      Tùy chọn bộ lọc
                    </div>
                  </div>
                  <!--end::Header-->
                  <!--begin::Separator-->

                  <div class="separator border-gray-200"></div>
                  <!--end::Separator-->
                  <form action="" @submit.prevent="onFilterSearchFirst">
                    <!--begin::Content-->
                    <div
                      class="px-7 py-5"
                      data-select2-id="select2-data-128-13oj"
                    >
                      <!--begin::Input group-->
                      <div>
                        <label class="form-label fs-5 fw-semibold mb-3"
                          >Ngày bắt đầu:</label
                        >
                        <v-date-picker
                          class="inline-block h-full"
                          v-model="dateStart"
                          :timezone="timezone2"
                        >
                          <template v-slot="{ inputValue, togglePopover }">
                            <div class="flex items-center">
                              <input
                                @click="togglePopover()"
                                :value="inputValue"
                                class="form-control form-control-solid flatpickr-input active"
                                name="calendar_event_end_date"
                                placeholder="Ngày bắt đầu"
                                id="kt_calendar_datepicker_end_date"
                                type="text"
                                readonly="readonly"
                                style="margin-bottom: 20px"
                              />
                            </div>
                          </template>
                        </v-date-picker>
                      </div>
                      <!--end::Input group-->

                      <!--begin::Input group-->
                      <div>
                        <label class="form-label fs-5 fw-semibold mb-3"
                          >Ngày kết thúc:</label
                        >
                        <v-date-picker
                          class="inline-block h-full"
                          v-model="dateEnd"
                          :timezone="timezone1"
                        >
                          <template v-slot="{ inputValue, togglePopover }">
                            <div class="flex items-center">
                              <input
                                @click="togglePopover()"
                                :value="inputValue"
                                class="form-control form-control-solid flatpickr-input active"
                                name="calendar_event_end_date"
                                placeholder="Ngày bắt đầu"
                                id="kt_calendar_datepicker_end_date"
                                type="text"
                                readonly="readonly"
                                style="margin-bottom: 20px"
                              />
                            </div>
                          </template>
                        </v-date-picker>
                      </div>
                      <!--end::Input group-->

                      <div class="group-status">
                      <!--begin::Input group-->
                      <div class="mb-10">
                        <!--begin::Label-->
                        <label class="form-label fs-5 fw-semibold mb-3"
                          >Trạng thái:</label
                        >
                        <!--end::Label-->
                        <!--begin::Options-->
                        <div
                          class="d-flex flex-column flex-wrap fw-semibold"
                          data-kt-customer-table-filter="payment_type"
                        >
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type"
                              value="Hợp lệ"
                              v-model="this.status"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Hợp lệ</span
                              ><br />
                            
                            </div>
                          </label>
                          <!--end::Option-->
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type"
                              value="Không hợp lệ"
                              v-model="this.status"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Không hợp lệ</span
                              ><br />
                            
                            </div>
                          </label>
                          <!--end::Option-->
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type"
                              value="Pending"
                              v-model="this.status"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Pending</span
                              ><br />
                              
                            </div>
                          </label>
                          <!--end::Option-->
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type"
                              value="Hold"
                              v-model="this.status"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Hold</span
                              ><br />
                            
                            </div>
                          </label>
                          <!--end::Option-->
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type"
                              value="Trả hold"
                              v-model="this.status"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Trả hold</span
                              ><br />
                            
                            </div>
                          </label>
                          <!--end::Option-->
                        </div>
                        <!--end::Options-->
                      </div>
                      <!--end::Input group-->

                      
                      <!--begin::Input group-->
                      <div class="mb-10">
                        <!--begin::Label-->
                        <label class="form-label fs-5 fw-semibold mb-3"
                          >Trạng thái tài khoản:</label
                        >
                        <!--end::Label-->
                        <!--begin::Options-->
                        <div
                          class="d-flex flex-column flex-wrap fw-semibold"
                          data-kt-customer-table-filter="payment_type"
                        >
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type_2"
                              value="Hợp lệ"
                              v-model="this.statusAccount"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Hợp lệ</span
                              ><br />
                            
                            </div>
                          </label>
                          <!--end::Option-->
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type_2"
                              value="Không hợp lệ"
                              v-model="this.statusAccount"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Không hợp lệ</span
                              ><br />
                             
                            </div>
                          </label>
                          <!--end::Option-->
                          <!--begin::Option-->
                          <label
                            class="form-check form-check-sm form-check-custom form-check-solid mb-7 me-5"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="payment_type_2  "
                              value="Pending"
                              v-model="this.statusAccount"
                            />
                            <div>
                              <span class="form-check-label text-gray-600"
                                >Pending</span
                              ><br />
                            
                            </div>
                          </label>
                          <!--end::Option-->
                        </div>
                        <!--end::Options-->
                      </div>
                    </div> 
                      <!--end::Input group-->
                      <!--begin::Actions-->
                      <div class="d-flex justify-content-end">
                        <button
                          @click="onResetFilter"
                          type="reset"
                          class="btn btn-light btn-active-light-primary me-2"
                          data-kt-menu-dismiss="true"
                          data-kt-customer-table-filter="reset"
                        >
                          Đặt lại
                        </button>
                        <button
                          type="submit"
                          class="btn btn-primary"
                          data-kt-menu-dismiss="true"
                          data-kt-customer-table-filter="filter"
                        >
                          Lọc
                        </button>
                      </div>
                      <!--end::Actions-->
                    </div>
                    <!--end::Content-->
                  </form>
                </div>
                <!--end::Menu 1-->
                <!--end::Filter-->
              </div>
              <!--end::Toolbar-->
              <!--begin::Group actions-->
              <div
                class="d-flex justify-content-end align-items-center d-none"
                data-kt-customer-table-toolbar="selected"
              >
                <div class="fw-bold me-5">
                  <span
                    class="me-2"
                    data-kt-customer-table-select="selected_count"
                  ></span
                  >Selected
                </div>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-kt-customer-table-select="delete_selected"
                >
                  Delete Selected
                </button>
              </div>
              <!--end::Group actions-->
            </div>

            <!--end::Card toolbar-->
          </div>
          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0" style="margin-top: 20px">
            <!--begin::Table-->
            <table
              class="table align-middle table-row-dashed fs-6 gy-5"
              id="kt_customers_table"
            >
              <thead>
                <tr
                  class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0"
                >
                  <!-- <th class="min-w-125px">Mã số hóa đơn</th>
                      <th class="min-w-125px">Số tiền nạp</th>
                      <th class="min-w-125px">Thời gian tạo</th>
                      <th class="min-w-125px">Thời gian thanh toán</th>
                      <th class="min-w-125px">Trạng thái</th>
                      <th class="min-w-125px">Ngân hàng thanh toán</th>
                      <th class="min-w-125px">Chủ tài khoản thanh toán</th>
                      <th class="min-w-125px">Số tài khoản thanh toán</th> -->
                      <th class="fix-data-0">
                  <div class="form-check" >
                    <input v-model="isCheckedAll" class="form-check-input" @click="selectAllRecord" type="checkbox" :class="{active__record: onSelectAllRecord}" id="flexCheckChecked" :checked="this.selectAllRecord === true" />
                    <label for="flexCheckChecked" ></label>
                  </div>
                </th>
                  <template v-for="(column, index) in columns" :key="index">
                    <th
                      class="min-w-125px"
                      :class="{
                        sorting_desc: this.sortingNumber == index,
                        sorting_asc: this.sortingAsc == index,
                      }"
                      :style="{ width: column.width + 'px !important' }"
                    >
                      <div @mousedown="startResize($event, index)">
                        <span
                          @click="
                            onSorting(index, column.property, 'changeSort')
                          "
                          >{{ column.label }}</span
                        >
                      </div>
                    </th>
                  </template>
                  <th class="text-end min-w-70px">Chức năng</th>
                </tr>
              </thead>
              <div class="loading" v-if="onLoading">
                <span class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              </div>
              <div id="noData" v-if="!this.onLoading && this.hasData == false">
                Chưa có dữ liệu giao dịch
              </div>
              <tbody
                v-if="!this.onLoading && this.hasData == true"
                class="fw-semibold text-gray-600"
              >
                <tr ref="source" :class="{active__record:(selectRecord && recordActiveId == billLog.idBillLog) || onSelectAllRecord}" v-for="billLog in billLogs" :key="billLog.billLogId">
                  <td  class="fix-data-0">
                        <div class="form-check">
                          <input :id="billLog.idBillLog" type="checkbox"  :value="billLog.idBillLog" name="check" :class="{count__record: isChecked(billLog.idBillLog)}" class="form-check-input"  v-model="checkboxChecked" />
                          <label :for="billLog.idBillLog"></label>
                        </div>
                    </td>

                  <td>
                    <a class="text-gray-800 text-hover-primary mb-1">{{
                      billLog.idBillLog
                    }}</a>
                  </td>
                  <td>{{ billLog.bankName }}</td>
               
                  <td>{{ formatDateTime(billLog.timeCheck) }}</td>
                  <td>{{ billLog.accountHolder }}</td>
                  <td>
                    <a class="text-gray-600 text-hover-primary mb-1"
                      >{{ billLog.cardNumber }}
                    </a>
                  </td>
                  <td>{{ formatDateTime(billLog.time) }}</td>

                  <td>{{ formatCurrency(billLog.amount) }}</td>
                  <td>{{ billLog.currency }}</td>
                  <td>{{ formatCurrency(billLog.amountConverted) }}</td>
                  <td>{{ formatCurrency(billLog.exchangeRate) }}</td>

                  <td>{{ billLog.transactionCode }}</td>
                  <td>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.status == 'Không hợp lệ'"
                        :class="`badge badge-light-danger`"
                      >
                        Không hợp lệ
                      </div>
                    </a>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.status == 'Hold'"
                        :class="`badge badge-light-warning`"
                      >
                      Hold
                      </div>
                    </a>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.status == 'Trả hold'"
                        :class="`badge badge-light-warning`"
                      >
                      Trả hold
                      </div>
                    </a>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.status == 'Hợp lệ'"
                        :class="`badge badge-light-success`"
                      >
                        Hợp lệ
                      </div>
                    </a>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.status == 'Pending'"
                        :class="`badge badge-light-warning`"
                      >
                        Pending
                      </div>
                    </a>
                  </td>
                  <td>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.accountStatus == 'Không hợp lệ'"
                        :class="`badge badge-light-danger`"
                      >
                        Không hợp lệ
                      </div>
                    </a>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.accountStatus == 'Hợp lệ'"
                        :class="`badge badge-light-success`"
                      >
                        Hợp lệ
                      </div>
                    </a>
                    <a class="text-gray-600 text-hover-primary mb-1">
                      <div
                        v-if="billLog.accountStatus == 'Pending'"
                        :class="`badge badge-light-warning`"
                      >
                        Pending
                      </div>
                    </a>
                  </td>
                  <td>{{ billLog.adId }}</td>
                  <td>{{ billLog.accountCode }}</td>
                  <td>{{ billLog.accountName }}</td>
                  <td>{{ formatCurrency(billLog.amountRemain) }}</td>
                  <td ref="target"
                    class="text-end"
                   

                    :class="{
                      active__update__combobox:
                        onShowMenu && currenOnshowId === billLog.idBillLog,
                    }"
                  >
                    <!-- <a
                      @click="openModalEmailHtml(billLog.idBillLog)"
                      class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary show menu-dropdown"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                      >Chi tiết</a
                    > -->
                    <a
                      @click="toggleMenuItem(billLog.idBillLog)"
                      class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary show menu-dropdown"
                      style="min-width: 120px;"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                      >Xem chi tiết <i class="ki-duotone ki-down fs-5 ms-1"></i
                    ></a>          
                    <!--begin::Menu-->
                    <div
                      class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 py-4" style="width:135px !important"
                      :class="{
                        show: onShowMenu && currenOnshowId === billLog.idBillLog,
                      }"
                      data-kt-menu="true"
                      @mouseleave="closeMenuItem"
                    >
                      <!--begin::Menu item-->
                      <div class="menu-item px-3">
                        <a
                          @click="confirmUpdateStatusBillLog(billLog.idBillLog)"
                          class="menu-link px-3"
                          >Yêu cầu cập nhật</a
                        > 
                      </div>
                      <!--end::Menu item-->
                       <!--begin::Menu item-->
                       <div class="menu-item px-3">
                        <a
                      @click="openModalEmailHtml(billLog.idBillLog)"
                      class="menu-link px-3"

                      >Chi tiết</a
                    >
                      </div>
                      <!--end::Menu item-->
                    </div>
                    <!--end::Menu-->
                    
                  </td>
                </tr>
                <tr id="total">
                  <td class="fix-data-footer"  colspan="2" style="font-weight: bold"> <img src="./../../../../public/frontend/media/logos/logo3.png" style="width:30px;height:auto"/>  {{this.billLogs.length}} BillLog</td> 
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{formatCurrency(totalAmount)}} đ</td>
                  <td></td>
                  <td>{{formatCurrency(totalAmountConverted)}} đ</td>
                  <td></td>
                  <td></td>          
                  <td></td>
                  <td></td>
                  <td></td>              
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div class="row">
              <div
                class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"
              >
                <div class="dataTables_length" id="kt_customers_table_length">
                  <label>
                    <v-select
                      v-model="this.pageSize"
                      id="styleSelect"
                      :options="numberPerPage"
                      label="value"
                    ></v-select>
                  </label>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
              >
                <div
                  class="dataTables_paginate paging_simple_numbers"
                  id="kt_customers_table_paginate"
                >
                  <ul v-if="this.totalPage >= 4" class="pagination">
                    <li
                      class="paginate_button page-item previous"
                      :class="{ disabled: this.pageNumber == 1 }"
                      id="kt_customers_table_previous"
                    >
                      <a
                        @click="prevPage"
                        aria-controls="kt_customers_table"
                        data-dt-idx="0"
                        tabindex="0"
                        class="page-link"
                        ><i class="previous"></i
                      ></a>
                    </li>
                    <li
                      v-for="index in 4"
                      :key="index"
                      class="paginate_button page-item"
                      :class="{ active: pageNumber == this.firstPage + index }"
                    >
                      <a
                        @click="selectPage(this.firstPage + index)"
                        aria-controls="kt_customers_table"
                        data-dt-idx="1"
                        tabindex="0"
                        class="page-link"
                        >{{ this.firstPage + index }}</a
                      >
                    </li>
                    <li
                      class="paginate_button page-item next"
                      :class="{ disabled: this.pageNumber == this.totalPage }"
                      id="kt_customers_table_next"
                    >
                      <a
                        @click="nextPage"
                        aria-controls="kt_customers_table"
                        data-dt-idx="5"
                        tabindex="0"
                        class="page-link"
                        ><i class="next"></i
                      ></a>
                    </li>
                  </ul>
                  <ul v-if="this.totalPage < 4" class="pagination">
                    <li
                      class="paginate_button page-item previous"
                      :class="{ disabled: this.pageNumber == 1 }"
                      id="kt_customers_table_previous"
                    >
                      <a
                        @click="prevPage"
                        aria-controls="kt_customers_table"
                        data-dt-idx="0"
                        tabindex="0"
                        class="page-link"
                        ><i class="previous"></i
                      ></a>
                    </li>
                    <li
                      v-for="index in totalPage"
                      :key="index"
                      class="paginate_button page-item"
                      :class="{ active: pageNumber == this.firstPage + index }"
                    >
                      <a
                        @click="selectPage(this.firstPage + index)"
                        aria-controls="kt_customers_table"
                        data-dt-idx="1"
                        tabindex="0"
                        class="page-link"
                        >{{ this.firstPage + index }}</a
                      >
                    </li>
                    <li
                      class="paginate_button page-item next"
                      :class="{ disabled: this.pageNumber == this.totalPage }"
                      id="kt_customers_table_next"
                    >
                      <a
                        @click="nextPage"
                        aria-controls="kt_customers_table"
                        data-dt-idx="5"
                        tabindex="0"
                        class="page-link"
                        ><i class="next"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--end::Table-->
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
        <!--begin::Modals-->

 <!--begin::Modal - Card - Info-->
 <div
          class="modal fade show"
          :class="{ block: onShowModalAllCardInfo }"
          id="kt_modal_add_customer"
          tabindex="-1"
          aria-hidden="true"
        >
          <!--begin::Modal dialog-->
          <div class="modal-dialog modal-dialog-centered mw-650px">
            <!--begin::Modal content-->
            <div class="modal-content" style="width:160%">
              <!--begin::Form-->
              <form
                class="form"
                id="kt_modal_add_customer_form"
                action=""
                @submit.prevent="openModalAddBatchCardInfo"
              >
                <!--begin::Modal header-->
                <div class="modal-header" id="kt_modal_add_customer_header">
                  <!--begin::Modal title-->
                  <h2 class="fw-bold"> Thông tin các thẻ</h2>
                  <!--end::Modal title-->
                  <!--begin::Close-->
                  <div
                    @click="closeModalAllCardInfo"
                    id="kt_modal_add_customer_close"
                    class="btn btn-icon btn-sm btn-active-icon-primary"
                  >
                    <i class="ki-duotone ki-cross fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>                                                                                                                                                                     
                    </i>
                  </div>
                  <!--end::Close-->
                </div>
                <!--end::Modal header-->
                <!--begin::Modal body-->
                <div class="modal-body py-10 px-lg-17">
                  <!--begin::Scroll-->
                  <div
                    class="scroll-y me-n7 pe-7"
                    id="kt_modal_add_customer_scroll"
                    data-kt-scroll="true"
                    data-kt-scroll-activate="{default: false, lg: true}"
                    data-kt-scroll-max-height="auto"
                    data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                    data-kt-scroll-wrappers="#kt_modal_add_customer_scroll"
                    data-kt-scroll-offset="300px"
                  >
                  <table
              class="table align-middle table-row-dashed fs-6 gy-5"
              id="kt_customers_table"
            >
              <thead>
                <tr
                  class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0"
                >
                  <th class="min-w-125px">Số thẻ</th>
                  <th class="min-w-125px">Tên thẻ</th>
                  <th class="min-w-125px">Chức năng</th>
                </tr>
              </thead>
              <div class="loading" v-if="onLoading">
                <span class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              </div>
              <div id="noData" v-if="!this.onLoading && this.hasData == false">
                {{ this.$NOLIMITResource["VN"].EmptyData }}
              </div>
              <tbody
                v-if="!this.onLoading && this.hasData == true"
                class="fw-semibold text-gray-600"
              >
                <tr
                  v-for="item in listCardInfo"
                  :key="item.id"
                >
                  <td>
                    <a
                      class="text-gray-800 text-hover-primary mb-1"
                      >{{ item.cardNumber }}</a
                    >
                  </td>
                  <td>
                    <a
                      class="text-gray-800 text-hover-primary mb-1"
                      >{{ item.cardName }}</a
                    >
                  </td>
                  <td class="text-end" style="display: flex; height: 75px;">
                  
                  <a @click="confirmDeleteCard(item.id,item.cardNumber)"
                    class="btn btn-light-danger btn-sm"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                    >Xóa</a
                  >
                </td>
                </tr>
              </tbody>
            </table>
                    
                     
                 
                 
                  </div>
                  <!--end::Scroll-->
                </div>
                <!--end::Modal body-->
                <!--begin::Modal footer-->
                <div class="modal-footer flex-center">
                  <!--begin::Button-->
                  <button
                    @click="closeModalAllCardInfo"
                    type="reset"
                    id="kt_modal_add_customer_cancel"
                    class="btn btn-light me-3"
                  >
                  Đóng
                  </button>
                  <!--end::Button-->
                  <!--begin::Button-->
                  <button
                    type="submit"
                    id="kt_modal_add_customer_submit"
                    class="btn btn-primary"
                  >
                  
                    <span @click="openModalAddBatchCardInfo" class="indicator-label"> Thêm thẻ</span>
                    <span class="indicator-progress"
                      >Please wait...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span
                    ></span>
                  </button>
                  <!--end::Button-->
                </div>
                <!--end::Modal footer-->
              </form>
              <!--end::Form-->
            </div>
          </div>
          
        </div>
        <!--end::Modal - Card - Info-->



         <!--begin::Modal - Add CardInfo-->
         <div
          class="modal fade show"
          :class="{ block: isShowModalAddBatchCardInfo }"
          id="kt_customers_export_modal"
          tabindex="-1"
          aria-hidden="true"
        >
          <!--begin::Modal dialog-->
          <div class="modal-dialog modal-dialog-centered mw-650px">
            <!--begin::Modal content-->
            <div class="modal-content">
              <!--begin::Modal header-->
              <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="fw-bold">Thêm các thẻ (Số thẻ|Tên thẻ)</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div
                  id="kt_customers_export_close"
                  class="btn btn-icon btn-sm btn-active-icon-primary"
                >
                  <i class="ki-duotone ki-cross fs-1" @click="closeModalAddBatchCardInfo">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </div>
                <!--end::Close-->
              </div>
              <!--end::Modal header-->
              <!--begin::Modal body-->
              <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
                <!--begin::Form-->
                <form id="kt_customers_export_form" class="form" action="" @submit.prevent="convertStringToArray()">
                  
                  <!--begin::Input group-->
                  <div class="input-group input-group-solid " style="margin-bottom: 50px;">
                    <label
                      class="d-flex align-items-center fs-6 fw-semibold form-label mb-2"
                    >
                      <span>Thông tin thẻ</span>
                      <span
                        class="ms-1"
                        data-bs-toggle="tooltip"
                        title="Thông tin thẻ"
                      >
                        <i
                          class="ki-duotone ki-information-5 text-gray-500 fs-6"
                        >
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                        </i>
                      </span>
                    </label>
                      <textarea v-model="this.cardInfoImport" class="form-control" style="width: 100%;" aria-label="With textarea"></textarea>
                  </div>
                  <!--end::Input group-->


                  <!--begin::Actions-->
                  <div class="text-center">
                    <button
                      type="reset"
                      id="kt_customers_export_cancel"
                      class="btn btn-light me-3"
                      @click="closeModalAddBatchCardInfo"
                    >
                    Đóng
                    </button>
                    <button
                    type="submit"
                      id="kt_customers_export_cancel"
                      class="btn  btn-info me-3"
                    >
                   Thêm
                    </button>
                   
                  </div>
                  <!--end::Actions-->
                </form>
                <!--end::Form-->
              </div>
              <!--end::Modal body-->
            </div>
            <!--end::Modal content-->
          </div>
          <!--end::Modal dialog-->
        </div>
        <!--end::Modal - Add CardInfo-->

        <!--begin::Modal - Email - HTML-->
        <div
          class="modal fade show"
          :class="{ block: isShowModalEmailHtml }"
          id="kt_modal_add_customer"
          tabindex="-1"
          aria-hidden="true"
        >
          <!--begin::Modal dialog-->
          <div class="modal-dialog modal-dialog-centered mw-650px">
            <!--begin::Modal content-->
            <div class="modal-content" style="width: 160%">
              <!--begin::Form-->
              <form
                class="form"
                id="kt_modal_add_customer_form"
                action=""
                @submit.prevent="closeModalEmailHtml"
              >
                <!--begin::Modal header-->
                <div class="modal-header" id="kt_modal_add_customer_header">
                  <!--begin::Modal title-->
                  <h2 class="fw-bold">Email HTML</h2>
                  <!--end::Modal title-->
                  <!--begin::Close-->
                  <div
                    @click="closeModalEmailHtml"
                    id="kt_modal_add_customer_close"
                    class="btn btn-icon btn-sm btn-active-icon-primary"
                  >
                    <i class="ki-duotone ki-cross fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </div>
                  <!--end::Close-->
                </div>
                <!--end::Modal header-->
                <!--begin::Modal body-->
                <div class="modal-body py-10 px-lg-17">
                  <!--begin::Scroll-->
                  <div
                    class="scroll-y me-n7 pe-7"
                    id="kt_modal_add_customer_scroll"
                    data-kt-scroll="true"
                    data-kt-scroll-activate="{default: false, lg: true}"
                    data-kt-scroll-max-height="auto"
                    data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                    data-kt-scroll-wrappers="#kt_modal_add_customer_scroll"
                    data-kt-scroll-offset="300px"
                  >
                    <div v-html="emailHtmlCurrent"></div>
                  </div>
                  <!--end::Scroll-->
                </div>
                <!--end::Modal body-->
                <!--begin::Modal footer-->
                <div class="modal-footer flex-center">
                  <!--begin::Button-->
                  <button
                    type="submit"
                    id="kt_modal_add_customer_submit"
                    class="btn btn-primary"
                  >
                    <span class="indicator-label">Đóng</span>
                    <span class="indicator-progress"
                      >Please wait...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span
                    ></span>
                  </button>
                  <!--end::Button-->
                </div>
                <!--end::Modal footer-->
              </form>
              <!--end::Form-->
            </div>
          </div>
        </div>
        <!--end::Modal - Email - HTML-->
      </div>
      <!--end::Content container-->
    </div>

    <!--end::Content-->
  </div>
</template>

    <style scoped>
    .text-end{
      padding-right: 30px !important;
    }
        .table thead th:last-child{
          display:table-cell;
          
        }
    .group-status{
      display: flex;
      justify-content: space-around;
    }
.table {
  overflow: scroll;
}
.loading {
  height: 500px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 50px;
}
tr td {
  text-align: start;
}
.menu-sub-dropdown {
  position: absolute;
}
.block {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
.show-dropfilter {
  z-index: 107;
  position: absolute;
  inset: 0px 0px auto auto;
  margin: 0px;
  top: 90px !important;
  right: 20px !important;
  left:auto !important;
  text-align: start;
}
table tr#total:hover td {
  background-color: #fff !important;
}
.table tr#total {
  position: sticky;
  bottom: 0px;
  left: 0;
  background: #fff;
  z-index: 4;
}
.table tr#total {
  position: sticky;
}
.fix-data-0{
    position: sticky;
    left:0px;
    top:0px;
    background: #fff;
  }
  #selected__toolbar{
    margin-right: 16px;
}
#selected__toolbar span{
    font-weight: 700;
}
.active__update__combobox {
    z-index: 5 !important;
  }
.menu {
    left: -20px;
    top: 53px;

  }
</style>
    <script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import router from "@/router/router.js";
export default {
  name: "BillLog",
  data() {
    return {
      cardInfoImport:"",
      isShowModalAddBatchCardInfo:false,
      listCardInfo:[],
      onShowModalAllCardInfo:false,
      recordActiveId:0,
      selectRecord: false,
      isCheckedAll: false,
      onSelectAllRecord:false,
      checkboxChecked:[],
      countSelected:0,
      currencyConvert: {
        value: 0,
      },
      totalAmount:0,
      totalAmountConverted:0,
      isShowModalEmailHtml: false,
      currentIndex: null,
      currentProperty: "",
      modeSort: "",
      sortingAsc: null,
      sortingNumber: null,
      isResizing: false,
      initialX: 0,
      initialWidth: 0,
      resizingCol: null,
      columns: [
        { label: "STT", width: 200, property: "IdBillLog" },
        { label: "Tên ngân hàng", width: 200, property: "BankName" },
   
        { label: "Time check", width: 200, property: "TimeCheck" },
        { label: "Chủ tài khoản", width: 200, property: "AccountHolder" },
        { label: "Số thẻ", width: 300, property: "CardNumber" },
        { label: "Time", width: 200, property: "Time" },
        { label: "Biến động", width: 200, property: "Amount" },
        { label: "Đơn vị tiền tệ", width: 200, property: "Currency" },
        { label: "Số tiền chuyển đổi", width: 200, property: "AmountConverted" },
        { label: "Tỷ giá", width: 200, property: "ExchangeRate" },

        { label: "Mã giao dịch", width: 200, property: "TransactionCode" },
        { label: "Trạng thái", width: 200, property: "Status" },
        {
          label: "Trạng thái tài khoản",
          width: 200,
          property: "AccountStatus",
        },
        { label: "FacebookAdId", width: 200, property: "AdId" },
        { label: "AccountCode", width: 200, property: "AccountCode" },
        { label: "AccountName", width: 200, property: "AccountName" },
        { label: "Còn lại", width: 200, property: "AmountRemain" },
      ],
      totalStatusSuccess: 0,
      totalStatusProcessing: 0,
      totalStatusNotSuccess: 0,
      emailHtmlCurrent: "",
      numberPerPage: [10, 50, 100, 500],
      onLoading: true,
      billLogs: [],
      onShowMenu: false,
      currenOnshowId: 0,
      isShowModal: false,
      currentBalanceUser: 0,
      currentTotalMoneyUser: 0,
      isShowModalUpdateUser: false,
      changeMoney: 0,
      formMode: "",
      pageSize: 10,
      pageNumber: 1,
      totalPage: 0,
      firstPage: 0,
      inputValue: "",
      userId: 0,
      isAdmin: true,
      hasData: true,
      status: "",
      statusAccount: "",
      dateStart: null,
      dateEnd: null,
      timezoneIndex: 19,
      timezoneIndex1: 1,
      timezones: [
        "Pacific/Midway", // -11
        "Pacific/Niue", // -11
        "Pacific/Honolulu", // -10
        "Pacific/Pago_Pago", // -11
        "America/Anchorage", // -9
        "America/Los_Angeles", // -8
        "America/Tijuana", // -8
        "America/Denver", // -7
        "America/Phoenix", // -7
        "America/Chicago", // -6
        "America/Mexico_City", // -6
        "America/Regina", // -6
        "America/New_York", // -5
        "America/Caracas", // -4.5
        "America/Halifax", // -4
        "America/Argentina/Buenos_Aires", // -3
        "America/Sao_Paulo", // -3
        "Atlantic/Azores", // -1
        "Atlantic/Cape_Verde", // -1
        "UTC", // 0
        "Europe/London", // +0
        "Europe/Paris", // +1
        "Europe/Istanbul", // +3
        "Europe/Moscow", // +3
        "Asia/Dubai", // +4
        "Asia/Yekaterinburg", // +5
        "Asia/Almaty", // +6
        "Asia/Colombo", // +6
        "Asia/Bangkok", // +7
        "Asia/Ho_Chi_Minh", // +7
        "Asia/Jakarta", // +7
        "Asia/Taipei", // +8
        "Asia/Singapore", // +8
        "Asia/Kuala_Lumpur", // +8
        "Asia/Hong_Kong", // +8
        "Asia/Ulaanbaatar", // +8
        "Asia/Pyongyang", // +9
        "Asia/Tokyo", // +9
        "Australia/Darwin", // +9.5
        "Australia/Adelaide", // +10
        "Australia/Sydney", // +10
        "Pacific/Guam", // +10
        "Australia/Brisbane", // +10
        "Asia/Vladivostok", // +10
        "Pacific/Fiji", // +12
        "Pacific/Tongatapu", // +13
        "Pacific/Apia", // +13
      ],
    };
  },
  computed: {
    ...mapGetters("listModule", [
      "onShowMenuFilter",
      "formatCurrency",
      "formatDateTime",
    ]),
    timezone2() {
      return this.timezones[this.timezoneIndex];
    },
    timezone1() {
      return this.timezones[this.timezoneIndex1];
    },
    attributes() {
      return [
        {
          highlight: true,
          dates: this.dateStart,
        },
      ];
    },
  },
  updated()
     {
        if(this.onSelectAllRecord){
            this.countSelected = this.billLogs.length;
        }else{
            this.countSelected = document.querySelectorAll('.count__record').length;
        }
      },
  created() {
    this.closeMenuFilter();
    this.$apiService
      .getUserProfile()
      .then((res) => {
        this.userId = res.data.data.userId;
        if (res.data.data.isAdmin == false && res.data.data.isInternalAccountant != true) {
          this.isAdmin = false;
          router.push({ name: "ErrorNotFound" });
        }
        this.$apiService
          .getAllBillLog(this.pageNumber, this.pageSize)
          .then((res) => {
            setTimeout(() => (this.onLoading = false), 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          })
          .catch((error) => {
            console.error("Lỗi khi lấy dữ liệu:", error);
          });
      })
      .catch((error) => {
        console.error("Lỗi khi lấy dữ liệu:", error);
      });
      this.$apiService.getSettingById(4).then((res) => {
      this.currencyConvert.value = res.data.value;
    });


    
  },
  watch: {
    pageSize() {
      this.reDisplay();
    },
    billLogs(){
      this.totalAmount = 0;
      this.totalAmountConverted = 0;
      for(let i = 0; i<this.billLogs.length;i++){
        if(this.billLogs[i].currency == "VND"){
          this.totalAmount += this.billLogs[i].amount
          this.totalAmountConverted += this.billLogs[i].amountConverted
        }else if(this.billLogs[i].currency == "USD"){
          this.totalAmount += (this.billLogs[i].amount * this.currencyConvert.value)
          this.totalAmountConverted += (this.billLogs[i].amountConverted * this.currencyConvert.value)
        }
      }
    }
  },
  mounted() {
    this.$watch(
      () => this.$refs.source.offsetHeight,
      () => {
        const sourceHeight = this.$refs.source.offsetHeight;
        this.$refs.target.style.height = sourceHeight + 'px';
      }
    );
  },
  methods: {
    ...mapActions("listModule", ["toggleMenuFilter","swalSuccess","swalError","swalWarning"]),
    ...mapMutations("listModule", ["closeMenuFilter"]),
    choosePageSize(event) {
      this.pageSize = event.target.value;
      this.reDisplay();
    },
    selectPage(index) {
      this.pageNumber = index;
      if (this.totalPage >= 4) {
        if (index == this.totalPage) {
          this.firstPage = index - 4;
        } else if (index >= 3) {
          this.firstPage = index - 3;
        } else {
          this.firstPage = 0;
        }
      }
      if (this.status != "" || this.dateStart != null || this.dateEnd != null) {
        this.onFilterSearch();
      } else if (this.sortingNumber != null || this.sortingAsc != null) {
        this.onSorting(this.currentIndex, this.currentProperty, "selectPage");
      } else {
        this.onEnterSearch();
      }
    },
    reDisplay() {
      this.hasData = true;
      this.$apiService
        .getAllBillLog(this.pageNumber, this.pageSize)
        .then((res) => {
          this.onLoading = true;
          setTimeout(() => (this.onLoading = false), 1000);
          this.billLogs = res.data.data;
          if (res.data.data.length == 0) {
            this.hasData = false;
          }
          this.totalPage = res.data.pageData.pageCount;
        })
        .catch((error) => {
          console.error("Lỗi khi lấy dữ liệu:", error);
        });
        this.unSelectAllRecord()
    },
    /**
     * Chọn next trang tiếp theo trong mục phân trang
     * Author: ndanh (20/09/2023)
     */
    nextPage() {
      if (this.pageNumber != this.totalPage) {
        this.pageNumber += 1;
        if (this.totalPage >= 4) {
          if (this.pageNumber == this.totalPage) {
            this.firstPage = this.pageNumber - 4;
          } else if (this.pageNumber >= 3) {
            this.firstPage = this.pageNumber - 3;
          } else {
            this.firstPage = 0;
          }
        }
      }
      if (this.status != "" || this.dateStart != null || this.dateEnd != null) {
        this.onFilterSearch();
      } else if (this.sortingNumber != null || this.sortingAsc != null) {
        this.onSorting(this.currentIndex, this.currentProperty, "selectPage");
      } else {
        this.onEnterSearch();
      }
    },
    /**
     * Chọn prev trang trước đó trong mục phân trang
     * Author: ndanh (20/09/2023)
     */
    prevPage() {
      if (this.pageNumber != 1) {
        this.pageNumber -= 1;
        if (this.totalPage >= 4) {
          if (this.pageNumber == this.totalPage) {
            this.firstPage = this.pageNumber - 4;
          } else if (this.pageNumber >= 3) {
            this.firstPage = this.pageNumber - 3;
          } else {
            this.firstPage = 0;
          }
        }
      }
      if (this.status != "" || this.dateStart != null || this.dateEnd != null) {
        this.onFilterSearch();
      } else if (this.sortingNumber != null || this.sortingAsc != null) {
        this.onSorting(this.currentIndex, this.currentProperty, "selectPage");
      } else {
        this.onEnterSearch();
      }
    },

    onEnterSearch() {
      this.hasData = true;
      if (this.inputValue == "") {
        this.reDisplay();
      } else {
        this.$apiService
          .getAllBillLogFilterStatus(this.pageNumber, this.pageSize,this.status,
            this.statusAccount,this.inputValue,this.currentProperty,
            this.modeSort)
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          })
          .catch((error) => {
            console.error("Lỗi khi lấy dữ liệu:", error);
          });
      }
    },
    onEnterSearchFirst() {
      this.hasData = true;
      if (this.inputValue == "") {
        this.reDisplay();
      } else {
        this.pageNumber = 1;
        this.firstPage = 0;
        this.$apiService
          .getAllBillLogFilterStatus(this.pageNumber, this.pageSize,  
           this.status,
            this.statusAccount, 
            this.inputValue,this.currentProperty,
            this.modeSort)
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          })
          .catch((error) => {
            console.error("Lỗi khi lấy dữ liệu:", error);
          });
      }
    },
    onFilterSearch() {
      this.hasData = true;
      if (
        (this.dateStart == null ||
          this.dateEnd == null ||
          this.dateEnd < this.dateStart) &&
        this.status == "" && this.statusAccount == "" && 
        this.inputValue == ""
      ) {
        this.reDisplay();
      } else if (
        this.dateStart == null ||
        this.dateEnd == null ||
        this.dateEnd < this.dateStart
      ) {
        this.$apiService
          .getAllBillLogFilterStatus(
            this.pageNumber,
            this.pageSize,
            this.status,
            this.statusAccount,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else if (this.status == "") {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            "",
            this.statusAccount,
            dateStartConvert,
            dateEndConvert,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else if (this.statusAccount == "") {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            this.status,
            "",
            dateStartConvert,
            dateEndConvert,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else if (this.inputValue == "") {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            this.status,
            this.statusAccount,
            dateStartConvert,
            dateEndConvert,
            "",
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            this.status,
            this.statusAccount,
            dateStartConvert,
            dateEndConvert,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      }
      this.closeMenuFilter();
    },
    onFilterSearchFirst() {

        this.hasData = true;
      if (
        (this.dateStart == null ||
          this.dateEnd == null ||
          this.dateEnd < this.dateStart) &&
        this.status == "" && this.statusAccount == "" && 
        this.inputValue == ""
      ) {
        this.reDisplay();
      } else
      this.pageNumber = 1;
        this.firstPage = 0;
      if (
        this.dateStart == null ||
        this.dateEnd == null ||
        this.dateEnd < this.dateStart
      ) {
   
        this.$apiService
          .getAllBillLogFilterStatus(
            this.pageNumber,
            this.pageSize,
            this.status,
            this.statusAccount,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else if (this.status == "") {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            "",
            this.statusAccount,
            dateStartConvert,
            dateEndConvert,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else if (this.statusAccount == "") {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            this.status,
            "",
            dateStartConvert,
            dateEndConvert,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else if (this.inputValue == "") {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            this.status,
            this.statusAccount,
            dateStartConvert,
            dateEndConvert,
            "",
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      } else {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        this.$apiService
          .getAllBillLogFilter(
            this.pageNumber,
            this.pageSize,
            this.status,
            this.statusAccount,
            dateStartConvert,
            dateEndConvert,
            this.inputValue,
            this.currentProperty,
            this.modeSort,
          )
          .then((res) => {
            this.onLoading = true;
            setTimeout(() => {
              this.onLoading = false;
            }, 1000);
            this.billLogs = res.data.data;
            if (res.data.data.length == 0) {
              this.hasData = false;
            }
            this.totalPage = res.data.pageData.pageCount;
          });
      }
      this.closeMenuFilter();
   
    },
    convertToEndOfDay(date) {
      date.setHours(23, 59, 59, 999);

      // Lấy các thành phần ngày giờ
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      const milliseconds = date.getMilliseconds().toString().padStart(3, "0");

      // Tạo chuỗi ISO
      const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
      return isoString;
    },
    convertToStartOfDay(date) {
      // Set giờ về 00:00:00.000
      date.setHours(0, 0, 0, 0);

      // Lấy các thành phần ngày giờ
      const year = date.getFullYear();
      // Lưu ý: getMonth() trả về 0-11, nên +1 cho đúng tháng
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const milliseconds = date.getMilliseconds().toString().padStart(3, '0');

      // Tạo chuỗi ISO
      const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
      return isoString;
    },
    onResetFilter() {
      this.status = "";
      this.dateStart = null;
      this.dateEnd = null;
    },
    startResize(event, index) {
      if (event.offsetX > event.target.offsetWidth - 10) {
        this.isResizing = true;
        this.initialX = event.clientX;
        this.initialWidth = this.columns[index].width;
        this.resizingCol = index;

        document.addEventListener("mousemove", this.handleMouseMove);
        document.addEventListener("mouseup", this.handleMouseUp);
      }
    },
    handleMouseMove(event) {
      if (this.isResizing && this.resizingCol !== null) {
        const delta = event.clientX - this.initialX;
        const newWidth = Math.max(50, this.initialWidth + delta);
        this.columns[this.resizingCol] = {
          ...this.columns[this.resizingCol],
          width: newWidth,
        };
      }
    },
    handleMouseUp() {
      this.isResizing = false;
      this.initialX = 0;
      this.initialWidth = 0;
      this.resizingCol = null;

      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseUp);
    },
    onSorting(index, property, mode) {
      this.hasData = true;
      this.currentIndex = index;
      this.currentProperty = property;
      if (
        this.dateStart == null ||
        this.dateEnd == null ||
        this.dateEnd < this.dateStart
      ) {
        if (this.sortingNumber == index && mode == "changeSort") {
          this.sortingNumber = null;
          this.sortingAsc = index;
          this.$apiService
            .getAllBillLogFilterStatus(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.inputValue,
              property,
              "ASC"
            )
            .then((res) => {
              this.modeSort = "ASC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else if (this.sortingNumber == index && mode == "selectPage") {
          this.sortingNumber = null;
          this.sortingAsc = null;
          this.sortingNumber = index;
          this.$apiService
            .getAllBillLogFilterStatus(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.inputValue,
              property,
              "DESC"
            )
            .then((res) => {
              this.modeSort = "DESC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else if (this.sortingAsc == index && mode == "changeSort") {
          this.sortingAsc = null;
          this.sortingNumber = index;
          this.$apiService
            .getAllBillLogFilterStatus(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.inputValue,
              property,
              "DESC"
            )
            .then((res) => {
              this.modeSort = "DESC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else if (this.sortingAsc == index && mode == "selectPage") {
          this.sortingAsc = null;
          this.sortingNumber = null;
          this.sortingAsc = index;
          this.$apiService
            .getAllBillLogFilterStatus(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.inputValue,
              property,
              "ASC"
            )
            .then((res) => {
              this.modeSort = "ASC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else {
          this.sortingNumber = null;
          this.sortingAsc = null;
          this.sortingNumber = index;
          this.$apiService
            .getAllBillLogFilterStatus(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.inputValue,
              property,
              "DESC"
            )
            .then((res) => {
              this.modeSort = "DESC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        }
      } else {
        const dateStartConvert = this.convertToStartOfDay(this.dateStart)
        const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
        if (this.sortingNumber == index && mode == "changeSort") {
          this.sortingNumber = null;
          this.sortingAsc = index;
          this.$apiService
            .getAllBillLogFilter(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              dateStartConvert,
              dateEndConvert,
              this.inputValue,
              property,
              "ASC"
            )
            .then((res) => {
              this.modeSort = "ASC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else if (this.sortingNumber == index && mode == "selectPage") {
          this.sortingNumber = null;
          this.sortingAsc = null;
          this.sortingNumber = index;
          this.$apiService
            .getAllBillLogFilter(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.dateStart.toISOString(),
              dateEndConvert,
              this.inputValue,
              property,
              "DESC"
            )
            .then((res) => {
              this.modeSort = "DESC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else if (this.sortingAsc == index && mode == "changeSort") {
          this.sortingAsc = null;
          this.sortingNumber = index;
          this.$apiService
            .getAllBillLogFilter(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.dateStart.toISOString(),
              dateEndConvert,
              this.inputValue,
              property,
              "DESC"
            )
            .then((res) => {
              this.modeSort = "DESC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else if (this.sortingAsc == index && mode == "selectPage") {
          this.sortingAsc = null;
          this.sortingNumber = null;
          this.sortingAsc = index;
          this.$apiService
            .getAllBillLogFilter(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.dateStart.toISOString(),
              dateEndConvert,
              this.inputValue,
              property,
              "ASC"
            )
            .then((res) => {
              this.modeSort = "ASC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        } else {
          this.sortingNumber = null;
          this.sortingAsc = null;
          this.sortingNumber = index;
          this.$apiService
            .getAllBillLogFilter(
              this.pageNumber,
              this.pageSize,
              this.status,
              this.statusAccount,
              this.dateStart.toISOString(),
              dateEndConvert,
              this.inputValue,
              property,
              "DESC"
            )
            .then((res) => {
              this.modeSort = "DESC";
              this.onLoading = true;
              setTimeout(() => {
                this.onLoading = false;
              }, 1000);
              this.billLogs = res.data.data;
              if (res.data.data.length == 0) {
                this.hasData = false;
              }
              this.totalPage = res.data.pageData.pageCount;
            })
            .catch((error) => {
              console.error("Lỗi khi lấy dữ liệu:", error);
            });
        }
      }
    },
    exportCSV() {
      let data = [];
      for (let i = 0; i < this.billLogs.length; i++) {
        let status;
        switch (this.billLogs[i].status) {
          case "Hợp lệ":
            status = "Hợp lệ";
            break;
            case "Hold":
            status = "Hold";
            break;
            case "Trả hold":
            status = "Trả hold";
            break;
          case "Pending":
            status = "Pending";
            break;
          case "Không hợp lệ":
            status = "Không hợp lệ";
            break;
          default:
            status = "Chưa xác định";
            break;
        }

        let accountStatus;
        switch (this.billLogs[i].accountStatus) {
          case "Hợp lệ":
            accountStatus = "Hợp lệ";
            break;
          case "Hold":
            status = "Hold";
            break;
          case "Trả hold":
            status = "Trả hold";
            break;  
          case "Pending":
            accountStatus = "Pending";
            break;
          case "Không hợp lệ":
            accountStatus = "Không hợp lệ";
            break;
          default:
            accountStatus = "Chưa xác định";
            break;
        }

        const item = {
          STT: this.billLogs[i].idBillLog,
          "Tên ngân hàng": this.billLogs[i].bankName,
          "Đơn vị tiền tệ": this.billLogs[i].currency,
          "Time check": this.formatDateTime(this.billLogs[i].timeCheck),
          "Chủ tài khoản": this.billLogs[i].accountHolder,
          "Số thẻ": this.billLogs[i].cardNumber,
          Time: this.formatDateTime(this.billLogs[i].time),
          "Biến động": this.billLogs[i].amount,
          "Mã giao dịch": this.billLogs[i].transactionCode,
          "Trạng thái": status,
          "Trạng thái tài khoản": accountStatus,
          FacebookAdId:"' "+ this.billLogs[i].adId,
          "AccountCode":this.billLogs[i].accountCode,
          "AccountName":this.billLogs[i].accountName,
        };

        data.push(item);
      }
      const csvContent1 = this.convertToCSV(data);
      var BOM = "\uFEFF";
      var csvContent = BOM + csvContent1;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export_billLogs.csv");
      link.click();
    },
    convertToCSV(data) {
      const headers = Object.keys(data[0]);
      const rows = data.map((obj) => headers.map((header) => obj[header]));
      const headerRow = headers.join(",");
      const csvRows = [headerRow, ...rows.map((row) => row.join(","))];
      return csvRows.join("\n");
    },
    openModalEmailHtml(id) {
      this.$apiService.getBillLogById(id).then((res) => {
        this.emailHtmlCurrent = res.data.data.emailHtml;

      });
      this.isShowModalEmailHtml = true;
    },
    closeModalEmailHtml() {
      this.isShowModalEmailHtml = false;
    },
     /**
         * Chọn một bản ghi theo checkbox
         * Author: ndanh (20/12/2023)
         * @param {int} id là id của bản ghi được chọn theo checkbox
         * @returns {int} trả về id đang được active
         */
         selectedRecord(id){
            this.recordActiveId = id;
            this.selectRecord= true;
            return this.recordActiveId;
        },
     /**
         * Chọn tất cả bản ghi theo checkbox
         * Author: ndanh (20/12/2023)
         */
         selectAllRecord(){
            if(this.onSelectAllRecord == false){
              this.onSelectAllRecord = true;
              this.isCheckedAll = true;
            this.checkboxChecked = [];
            if(this.onSelectAllRecord){
                for(let i = 0;i<this.billLogs.length;i++){
                    this.checkboxChecked.push(this.billLogs[i].idBillLog);
                }
            }
            }else{
              this.selectRecord= false;
              this.isCheckedAll = false;
            this.onSelectAllRecord = false;
            this.checkboxChecked = [];
            }
        },
          /**
         * Bỏ chọn tất cả bản ghi theo checkbox
         * Author: ndanh (20/12/2023)
         */
        unSelectAllRecord(){
          this.isCheckedAll = false;
            this.selectRecord= false;
            this.onSelectAllRecord = false;
            this.checkboxChecked = [];
        },
                /**
         * Kiểm trả xem id này có đang được checkbox checked hay không
         * Author: ndanh (20/12/2023)
         * @param {int} id là id được truyền vào để kiểm tra
         * @return {boolean} giá trị trả về true nếu id đang được checked
         */
         isChecked(id) {
              return this.checkboxChecked.includes(id) 
        },
        toggleMenuItem(id) {
          this.onShowMenu = !this.onShowMenu;
          this.currenOnshowId = id;
        },
        async confirmUpdateStatusBillLog(billLogId){
        const result = await this.swalWarning("Bạn có chắc chắn muốn cập nhật BillLog này ");
        if (result.isConfirmed) {
          this.updateStatusBillLog(billLogId)
        } else {
          // Thực hiện công việc khi người dùng hủy bỏ
        }
      },
        updateStatusBillLog(billLogId){
        this.$apiService.updateStatusBillLogByBillLogId(billLogId,"Pending").then(()=>{
          this.swalSuccess("Yêu cầu cập nhật thành công")
        }).catch((error) => {
          this.swalError(error.response.data.message)
        });
    },
    async confirmUpdateAllBillLogStatus(){
      const result = await this.swalWarning("Bạn có chắc chắn muốn cập nhật tất cả BillLog đã chọn  ");
      if (result.isConfirmed) {
        this.updateAllBillLogStatus()
      } else {
        // Thực hiện công việc khi người dùng hủy bỏ
      }
    },
    updateAllBillLogStatus(){
      this.$apiService.updateStatusManyBillLogByBillLogId(this.checkboxChecked,"Pending")
      .then(()=>{
        this.reDisplay();
          this.swalSuccess("Yêu cầu cập nhật các BillLog thành công!")
      }).catch((error) => {
          this.swalError(error.response.data.message)
        });
    },
    openModalAllCardInfo(){
      this.$apiService.getAllCardInfo().then((res)=>{
        this.listCardInfo = res.data;
      })
      this.onShowModalAllCardInfo = true;
    },
    closeModalAllCardInfo(){
      this.onShowModalAllCardInfo = false;
    },
    openModalAddBatchCardInfo(){
      this.isShowModalAddBatchCardInfo = true;
    },
    closeModalAddBatchCardInfo(){
      this.isShowModalAddBatchCardInfo = false;
    },
    convertStringToArray() {
      const formData = new FormData();
            formData.append('cardInfoData', this.cardInfoImport);
            this.$apiService.importManyCardInfo(formData)
            .then(()=>{
              this.reDisplay()
              this.swalSuccess("Thêm thẻ thành công!")
            this.closeModalAddBatchCardInfo();
            this.closeModalAllCardInfo();
            }).catch((error)=>{
              this.swalError({message:error.response.data.message, language: "VN"})
            })
        },
    async confirmDeleteCard(id,cardNumber){
      const result = await this.swalWarning( { message: "Bạn có chắc muốn xóa thẻ "+cardNumber, language: 'VN'});
      if (result.isConfirmed) {
        this.deleteCard(id)
      } else {
        // Thực hiện công việc khi người dùng hủy bỏ
      }
    },
    deleteCard(id){
      this.$apiService.deleteCard(id).then(()=>{
        this.swalSuccess("Xóa thẻ thành công!");
        this.closeModalAllCardInfo();
      }).catch((error) => {
          console.error("Lỗi khi lấy dữ liệu:", error);
        });
    }
  },
};
</script>
    